import { Quota } from '../objects/quota';
import { Config } from '../objects/config';
import { HeaderActionTypes, SET_CONFIG, SET_GOOGLE, UPDATE_QUOTA } from './actionTypes';

export const setConfig = (config: Config): HeaderActionTypes => ({
    type: SET_CONFIG,
    payload: config
});

export const setGoogle = (google: any): HeaderActionTypes => ({
    type: SET_GOOGLE,
    payload: google
});

export const updateQuota = (quota: Quota): HeaderActionTypes => ({
    type: UPDATE_QUOTA,
    payload: quota
});